import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import TermsRoute from "./routes/TermsRoute";
import DeleteAccountRoute from "./routes/DeleteAccountRoute";
import OtpVerifyRoute from "./routes/OtpVerifyRoute";
import VideoRoute from "./routes/VideoRoute";
import CsaeRoute from "./routes/CsaeRoute";

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/terms",
      element: <TermsRoute />,
    },
    {
      path:"/csae",
      element:<CsaeRoute />
    },
    {
      path: "/delete-account",
      element: <DeleteAccountRoute />,
    },
    {
      path:"/otp",
      element:<OtpVerifyRoute />
    },
    {
      path:"/video",
      element:<VideoRoute />
    },
    {
      path:"*",
      element:<Navigate to="/terms" />
    }
  ]);
  return <RouterProvider router={router} />;
};

export default App;
